import { TypographyColor } from 'melp-design/components';
import {
  PartnerAdminCognitoStatus,
  PartnerAdminStatus,
} from './admin-suppliers.types';

export const DEFAULT_EARNING_FEE_BPS = 0;
export const MAX_EARNING_FEE_PERCENT = 100;

export const earningFeeBpsToPercent = (bps: number) => bps / 100;

export const earningFeePercentToBps = (percent: number) =>
  Math.round(percent * 100);

export const COLOR_BY_PERIOD_STATUS: Record<
  'open' | 'closed',
  TypographyColor
> = {
  open: 'success',
  closed: 'textSecondary',
};

export const COLOR_BY_STATUS: Record<PartnerAdminStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};

export const COGNITO_CHIP_VARIANT: Record<
  PartnerAdminCognitoStatus,
  'success' | 'warning' | 'neutral'
> = {
  linked: 'success',
  unlinkedExists: 'warning',
  unlinkedMissing: 'neutral',
};
